import React from 'react';
import { Dialog, Paragraph, toaster } from 'evergreen-ui';
import { StationType } from 'Services/api/v2';
import { useDeleteStationMutation } from 'Services/api/stantionsApi';
import { MinimalDialogProps } from 'Shared/types';
import { useNavigate } from 'react-router-dom';

type DialogStationDeleteProps = MinimalDialogProps & {
  station: StationType,
}

export function DialogStationDelete({ isShown, station, onClose }: DialogStationDeleteProps) {
  const navigate = useNavigate();
  const [deleteStationMutation, { isLoading: isDeleting }] = useDeleteStationMutation();

  const closeDialog = () => onClose(false);

  const deleteStation = () => {
    deleteStationMutation(station.id)
      .unwrap()
      .then(() => {
        toaster.success('Станция удалена');
        closeDialog();
        navigate('/stations');
      })
      .catch(() => {
        closeDialog();
      });
  };

  if (!isShown) return null;
  return (
    <Dialog
      isShown
      title="Удалить станцию"
      intent="danger"
      onCloseComplete={closeDialog}
      confirmLabel="Удалить"
      onConfirm={deleteStation}
      cancelLabel="Отмена"
      isConfirmLoading={isDeleting}
    >
      <>
        <Paragraph>
          <b>id: </b>
          {station?.id}
        </Paragraph>
        <Paragraph>
          <b>Название: </b>
          {station?.name}
        </Paragraph>
      </>
    </Dialog>
  );
}
